/* tslint:disable */
/* eslint-disable */
/**
 * Guarantees API
 * Référentiel des garanties, rattachées aux branches
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RolePrimeDerivee } from './RolePrimeDerivee';
import {
    RolePrimeDeriveeFromJSON,
    RolePrimeDeriveeFromJSONTyped,
    RolePrimeDeriveeToJSON,
    RolePrimeDeriveeToJSONTyped,
} from './RolePrimeDerivee';

/**
 * Création d'une garantie dans le référentiel d'une branche.
 * @export
 * @interface CreateGarantieReferentielCommand
 */
export interface CreateGarantieReferentielCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateGarantieReferentielCommand
     */
    branchId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGarantieReferentielCommand
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGarantieReferentielCommand
     */
    shortLabel: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGarantieReferentielCommand
     */
    label: string;
    /**
     * 
     * @type {RolePrimeDerivee}
     * @memberof CreateGarantieReferentielCommand
     */
    derivedPremiumRole?: RolePrimeDerivee;
    /**
     * 
     * @type {boolean}
     * @memberof CreateGarantieReferentielCommand
     */
    damage?: boolean;
}



/**
 * Check if a given object implements the CreateGarantieReferentielCommand interface.
 */
export function instanceOfCreateGarantieReferentielCommand(value: object): value is CreateGarantieReferentielCommand {
    if (!('branchId' in value) || value['branchId'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('shortLabel' in value) || value['shortLabel'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function CreateGarantieReferentielCommandFromJSON(json: any): CreateGarantieReferentielCommand {
    return CreateGarantieReferentielCommandFromJSONTyped(json, false);
}

export function CreateGarantieReferentielCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateGarantieReferentielCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'branchId': json['branchId'],
        'code': json['code'],
        'shortLabel': json['shortLabel'],
        'label': json['label'],
        'derivedPremiumRole': json['derivedPremiumRole'] == null ? undefined : RolePrimeDeriveeFromJSON(json['derivedPremiumRole']),
        'damage': json['damage'] == null ? undefined : json['damage'],
    };
}

export function CreateGarantieReferentielCommandToJSON(json: any): CreateGarantieReferentielCommand {
    return CreateGarantieReferentielCommandToJSONTyped(json, false);
}

export function CreateGarantieReferentielCommandToJSONTyped(value?: CreateGarantieReferentielCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'branchId': value['branchId'],
        'code': value['code'],
        'shortLabel': value['shortLabel'],
        'label': value['label'],
        'derivedPremiumRole': RolePrimeDeriveeToJSON(value['derivedPremiumRole']),
        'damage': value['damage'],
    };
}

